import { env } from '../../config/env';
import type { ProductInput } from '../../types';
import type { Product } from '../../types';
import * as http from './productsService.http';
import * as mock from './productsService.mock';

export interface ProductsService {
  fetchProducts(): Promise<Product[]>;
  getProduct(id: string): Promise<Product>;
  createProduct(input: ProductInput): Promise<Product>;
  updateProduct(id: string, input: ProductInput): Promise<Product>;
  deleteProduct(id: string): Promise<void>;
  uploadProductImages(id: string, files: File[]): Promise<Product>;
  deleteProductImage(id: string, url: string): Promise<Product>;
}

const mockProductsService: ProductsService = {
  fetchProducts: mock.mockFetchProducts,
  getProduct: mock.mockGetProduct,
  createProduct: mock.mockCreateProduct,
  updateProduct: mock.mockUpdateProduct,
  deleteProduct: mock.mockDeleteProduct,
  uploadProductImages: mock.mockUploadProductImages,
  deleteProductImage: mock.mockDeleteProductImage,
};

const httpProductsService: ProductsService = {
  fetchProducts: http.httpFetchProducts,
  getProduct: http.httpGetProduct,
  createProduct: http.httpCreateProduct,
  updateProduct: http.httpUpdateProduct,
  deleteProduct: http.httpDeleteProduct,
  uploadProductImages: http.httpUploadProductImages,
  deleteProductImage: http.httpDeleteProductImage,
};

export const productsService: ProductsService = env.useMock
  ? mockProductsService
  : httpProductsService;
